import {useRef} from 'react'

import Style from './style'

import MainHeader from 'widget/MainHeader'

import useGetMyFranchise from 'entity/franchise/useGetMyFranchise'
import usePutMyFranchise from 'entity/franchise/usePutMyFranchise'
import usePostImgUpload from 'entity/util/usePostImgUpload'

import ITStyle from 'shared/style/inputTableStyle'
import useGetMyCompetition from 'entity/competition/useGetMyCompetition'
import usePutMyBrand from 'entity/competition/usePutMyBranch'

const MyBranchEdit = () => {
	const brandNameRef = useRef()

	// TODO 3rd: THE UI is not match with current hooks to get data (clone from MyFranchiseEdit)
	const [myData] = useGetMyCompetition()

	const [putMyBrand] = usePutMyBrand(brandNameRef)

	const btnList = [
		{
			label: '저장',
			clickEvent: () => putMyBrand(),
			deactive: false,
		},
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList} title='브랜드 정보 수정' />

			<ITStyle.TableDiv>
				<ITStyle.TableElement>
					<h2>
						브랜드 이름<span>*</span>
					</h2>
					<input
						ref={brandNameRef}
						placeholder='40글자 이하'
						defaultValue={myData?.data?.store_name}
					/>
				</ITStyle.TableElement>
			</ITStyle.TableDiv>
		</Style.Wrapper>
	)
}

export default MyBranchEdit
